import React from 'react';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Download from '@mui/icons-material/Download';
import Refresh from '@mui/icons-material/Refresh';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import CloudUpload from '@mui/icons-material/CloudUpload';
import { ScrapingStatus, ACTION_LABELS } from '../const';
import { isSuccessDemoStatus } from './status';

export type ScrapingAction = {
  label: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  url?: string;
};

type CreateScrapingActionsParams = {
  status: string | null;
  onInfo: () => void;
  onDownload: () => void;
  onRetry: () => void;
  onViewErrors: () => void;
  onDelete?: () => void;
  onRefreshDemo?: () => void;
  onUploadScreenshot?: () => void;
  downloading?: boolean;
  error?: string | null;
};

export const createScrapingActions = ({
  status,
  onInfo,
  onDownload,
  onRetry,
  onViewErrors,
  onDelete,
  onRefreshDemo,
  onUploadScreenshot,
  downloading = false,
  error,
}: CreateScrapingActionsParams): ScrapingAction[] => {
  const actions: ScrapingAction[] = [];

  actions.push({
    label: ACTION_LABELS.INFO,
    icon: React.createElement(InfoOutlined),
    onClick: onInfo,
  });

  switch (status) {
    case ScrapingStatus.SUBMITTED:
    case ScrapingStatus.PENDING:
    case ScrapingStatus.IN_PROCESS:
    case ScrapingStatus.STARTED:
    case ScrapingStatus.IN_PROCESS_PARSING:
    case ScrapingStatus.IN_PROCESS_KNOWLEDGE:
    case ScrapingStatus.IN_PROCESS_DEMO:
      if (onDelete) {
        actions.push({
          label: ACTION_LABELS.DELETE,
          icon: React.createElement(DeleteOutline),
          onClick: onDelete,
        });
      }
      break;

    case ScrapingStatus.SUCCESS:
    case ScrapingStatus.SUCCESS_PARSING:
    case ScrapingStatus.SUCCESS_KNOWLEDGE:
    case ScrapingStatus.SUCCESS_DEMO:
      actions.push({
        label: ACTION_LABELS.DOWNLOAD,
        icon: React.createElement(Download),
        onClick: onDownload,
        disabled: downloading,
      });
      if (onUploadScreenshot) {
        actions.push({
          label: ACTION_LABELS.UPLOAD_SCREENSHOT,
          icon: React.createElement(CloudUpload),
          onClick: onUploadScreenshot,
        });
      }
      if (isSuccessDemoStatus(status) && onRefreshDemo) {
        actions.push({
          label: ACTION_LABELS.REFRESH_DEMO,
          icon: React.createElement(Refresh),
          onClick: onRefreshDemo,
        });
      }
      if (onDelete) {
        actions.push({
          label: ACTION_LABELS.DELETE,
          icon: React.createElement(DeleteOutline),
          onClick: onDelete,
        });
      }
      break;

    case ScrapingStatus.FAILURE:
    case ScrapingStatus.FAILURE_PARSING:
    case ScrapingStatus.FAILURE_KNOWLEDGE:
    case ScrapingStatus.FAILURE_DEMO:
      if (error) {
        actions.push({
          label: ACTION_LABELS.VIEW_ERRORS,
          icon: React.createElement(ErrorOutline),
          onClick: onViewErrors,
        });
      }
      actions.push({
        label: ACTION_LABELS.RETRY,
        icon: React.createElement(Refresh),
        onClick: onRetry,
      });
      if (onDelete) {
        actions.push({
          label: ACTION_LABELS.DELETE,
          icon: React.createElement(DeleteOutline),
          onClick: onDelete,
        });
      }
      break;

    case ScrapingStatus.REVOKED:
      if (onDelete) {
        actions.push({
          label: ACTION_LABELS.DELETE,
          icon: React.createElement(DeleteOutline),
          onClick: onDelete,
        });
      }
      break;

    case ScrapingStatus.UNKNOWN:
    default:
      break;
  }

  return actions;
};
